import { CarePlanState } from '@seen/core/models/care-plans/constants'
import { InitialCarePlan } from '@seen/core/models/care-plans/InitialCarePlan'
import { useMemo } from 'react'
import { useParams } from 'react-router'
import { useSearch } from '#src/hooks/useSearch.ts'

export function useCurrentCarePlanURL(): { data: string; isPending: boolean } {
  const { patientId } = useParams()

  const { data: carePlans, isPending } = useSearch(
    InitialCarePlan,
    InitialCarePlan.byParticipant({
      reference: `Patient/${patientId}`,
    })
  )

  const currentCarePlan = useMemo(
    () =>
      carePlans?.find((carePlan) => carePlan.state === CarePlanState.Active) ??
      carePlans?.[0],
    [carePlans]
  )

  const currentCarePlanUrl = currentCarePlan
    ? `/Patient/${patientId}/care-plans/${currentCarePlan.id}`
    : `/Patient/${patientId}/care-plans`

  return useMemo(
    () => ({
      data: currentCarePlanUrl,
      isPending,
    }),
    [currentCarePlanUrl, isPending]
  )
}
